export default "__VITE_ASSET__DAj_GpfG__"